import { PUBLICIP_API_URL } from './publicIPEnum.js';
import createService from 'shared/utils/createService.js';

export default createService(PUBLICIP_API_URL, { withCredentials: false });
